import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Pagination } from '../../interfaces/pagination/pagination.DTO';
import { SolicitudCambiarEstadoI } from '../../models/solicitudCambiarEstado.interface';
import { ResponseBaseI } from '../../models/responseBase.interface';
import { PaginationResponseI } from '../../models/paginationResponse.interface';
import { ConsultaSolicitudesDisponiblesDTO } from '../../interfaces/referente/ConsultaSolicitudesDisponiblesDTO';
import { SolicitudesPendientesAprobacionDTO } from '../../interfaces/referente/SolicitudPendienteAprobacionDTO';
import { Solicitud } from '../../interfaces/referente/SolicitudDTO';
import { AgregarNovedadSolicitudI } from '../../models/agregarNovedadSolicitud';


@Injectable({
  providedIn: 'root'
})
export class ReferentApiService {

  URI = environment.urlAPI;

  constructor(
    private http: HttpClient
  ) { }


  postRequestService(payload: any) {
    return this.http.post<ResponseBaseI<Solicitud>>(`${this.URI}/Solicitud`, payload);
  }

  postSolicitudConsultaAprDir(pagination: Pagination) {
    return this.http.post<ResponseBaseI<PaginationResponseI<SolicitudesPendientesAprobacionDTO>>>(`${this.URI}/Solicitud/consultaAprobacionDirectivoClean`, pagination);
  }

  getSolicitudById(id: number) {
    return this.http.get<ResponseBaseI<Solicitud>>(`${this.URI}/Solicitud/${id}`);
  }

  putSolicitudCambiarestado( data: SolicitudCambiarEstadoI ) {
    return this.http.put<ResponseBaseI>(`${this.URI}/Solicitud/cambiarEstadoSolicitud`, data);
  }

  postSolicitudConsultaBanRef(pagination: Pagination) {
    return this.http.post<ResponseBaseI<PaginationResponseI<ConsultaSolicitudesDisponiblesDTO>>>(`${this.URI}/Solicitud/consultaBandejaReferente`, pagination);
  }

  putSolicitudServicio(solicitud: Solicitud) {
    return this.http.put<ResponseBaseI<Solicitud>>(`${this.URI}/Solicitud`, solicitud);
  }

  postSolicitudNovedades(novedad: AgregarNovedadSolicitudI) {
    return this.http.post<ResponseBaseI>(`${this.URI}/SolicitudNovedades`, novedad);
  }
}
